import { httpGet } from '@/services/http';
import { transformEvent, BackendEvent, FrontendEvent } from '@/services/transform';

/** GET /api/public/events - 获取公开活动列表 */
export async function getPublicEvents(): Promise<FrontendEvent[]> {
  try {
    const data = await httpGet<BackendEvent[]>('/public/events');
    return data.map(transformEvent).filter(e => e.status === 'published' || e.status === 'upcoming' || e.status === 'past');
  } catch (error) {
    console.error('获取公开活动列表失败:', error);
    return [];
  }
}

/** GET /api/public/events/upcoming - 获取即将举行的活动 */
export async function getUpcomingEvents(): Promise<FrontendEvent[]> {
  try {
    const data = await httpGet<BackendEvent[]>('/public/events/upcoming');
    return data.map(transformEvent);
  } catch (error) {
    console.error('获取即将举行的活动失败:', error);
    return [];
  }
}

/** GET /api/public/events/:id - 获取活动详情 */
export async function getPublicEventById(id: string): Promise<FrontendEvent | null> {
  try {
    const data = await httpGet<BackendEvent>(`/public/events/${id}`);
    return transformEvent(data);
  } catch (error) {
    console.error('获取活动详情失败:', error);
    return null;
  }
}
